export const FinalCta = () => (
  <section className="relative bg-gradient-to-b from-[#0c1220] to-[#080c14] py-24" data-testid="final-cta-section">
    <div className="mx-auto max-w-4xl px-6 text-center">
      <h2 className="mb-6 font-disp text-4xl uppercase text-white sm:text-6xl">Lock Your Departure Time Today</h2>
      <p className="mx-auto mb-10 max-w-md text-sm text-slate-400">Instant confirmation, zero airport parking hassles, direct terminal drop-off.</p>
      <a
        href="#book"
        data-testid="final-cta-book-button"
        className="inline-flex items-center gap-3 rounded-full bg-[#38bdf8] px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#0b101b] shadow-[0_0_30px_rgba(56,189,248,0.5)] transition-colors hover:bg-white"
      >
        <span>Book &amp; Pay via Stripe</span>
        <span>&rarr;</span>
      </a>
    </div>
  </section>
);
